import React from "react";
import { PropTypes } from "prop-types";

// TAB CONTENT SECTION

const FullPageTabPanel = ({ activeIndex, tabIndex, children }) => {
	return <>{activeIndex === tabIndex ? children : null}</>;
};

export default FullPageTabPanel;

FullPageTabPanel.defaultProps = {};

FullPageTabPanel.propTypes = {
	children: PropTypes.any.isRequired,
	activeIndex: PropTypes.number,
	tabIndex: PropTypes.number,
};
